import { render, staticRenderFns } from "./KasKecil.vue?vue&type=template&id=6a40efd2&"
import script from "./KasKecil.vue?vue&type=script&lang=js&"
export * from "./KasKecil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports